import {AbstractEditor, Dropzones} from 'substance'

class IdfEditorComponent extends AbstractEditor {
    getInitialState() {
        return {
            contextMenu: false,
            annotationMenu: false,
            contentMenu: false,
            hints: null
        }
    }

    didMount() {
        this._setSelectionToFirstElement()
    }

    render($$) {
        const doc = this.props.editorSession.getDocument()
        const {configurator} = this.context

        return $$('div')
            .append([
                $$('div').addClass('dwe-gutter'),
                $$(configurator.getComponent('dw-context-menu'), {
                    trigger: 'context'
                }),
                $$(configurator.getComponent('dw-annotation-menu'), {
                    trigger: 'selection'
                }),
                $$(configurator.getComponent('dw-content-menu'), {
                    trigger: 'selection'
                }),
                $$(Dropzones),
                $$(configurator.getComponent('body'), {
                    node: doc.get('body'),
                    textTypes: configurator.getTextTypes()
                })
            ])
    }

    _setSelectionToFirstElement() {
        const doc = this.context.editorSession.getDocument()
        const body = doc.get('body')
        const nodeId = body.nodes.find(id => {
            return doc.get(id).isText() ? true : false
        })

        if (nodeId) {
            this.props.editorSession.setSelection({
                type: 'node',
                nodeId: nodeId,
                containerId: 'body',
                surfaceId: 'body'
            })

            this.props.editorSession.setSelection({
                type: 'property',
                containerId: 'body',
                path: [nodeId, 'content'],
                startOffset: 0,
                endOffset: 0
            })
        }
    }
}

export {IdfEditorComponent}
